import React from "react";
import LogNav from "../layout/LoggedNav";
import RecentHistory from '../Billing/RecentHistory'
import MemberDetailBenifits from "../BillingEndBenifits/MemberDetailBenifits";

const BillingEndedBenifits = () => {

    return (
        <>
            <div className="billing">
                <h1 className="billing--title text-jost-sb-50-wt">Welcome to your account</h1>
                {/* <LogNav/> */}
                <div className="billing__wrap">
                    <MemberDetailBenifits/>
                    <RecentHistory/>
                </div>
            </div>
        </>
    );
};
export default BillingEndedBenifits;
